/**
 * 应用入口 —— React 18 + Ant Design 6 + React Router 7。
 * ConfigProvider 配置中文语言包 + 自定义主题（中国红主色调）。
 */
import React from 'react';
import dayjs from 'dayjs';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider, App } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import AppRouter from './router';
import ErrorBoundary from './ErrorBoundary';
import './index.css';
import { AuthProvider } from './auth/AuthContext';
import 'dayjs/locale/zh-cn';

dayjs.locale('zh-cn');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: {
          // 中国红主色调 —— 比 Ant Design 默认蓝色更符合管理后台气质
          colorPrimary: '#cf1322',
          borderRadius: 6,
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Microsoft YaHei", sans-serif',
        },
      }}
    >
      <App>
        <BrowserRouter basename="/tuanzhang">
          <AuthProvider>
            <ErrorBoundary>
              <AppRouter />
            </ErrorBoundary>
          </AuthProvider>
        </BrowserRouter>
      </App>
    </ConfigProvider>
  </React.StrictMode>,
);
